import React from "react";
import { captureException } from "../lib/posthog";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    captureException(error, {
      source: "react-error-boundary",
      componentStack: info?.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, fontFamily: "sans-serif" }}>
          Något gick fel.
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
